import { findComponentsBy } from 'common/utils/find-components-by';
import { findComponentBy } from 'utils/find-component-by';
import { BBModel, BBSymbolInfo, BBSymbolInstance, SelectedBBSingle, StorySymbols } from 'types/story';

/**
 * @param node {!object} bb node model
 * @returns {boolean}
 */
export const isSymbol = (node: BBModel | BBSymbolInstance | SelectedBBSingle) => node?.symbol?.masterId !== undefined;

/**
 * @param node {!object} bb node model
 * @returns {boolean}
 */
export const isSymbolChild = node => node.symbol?.childId !== undefined;

/**
 * @param children {!array} element children
 * @returns {Array<Object>}
 */
export const getNestedSymbols = children => findComponentsBy(children, isSymbol) as BBSymbolInstance[];

/**
 * @param children {Array} array of elements
 * @returns {{component: *, index: number}|boolean|*}
 */
export const hasSymbol = children => findComponentBy(children, { path: 'symbol.masterId', has: true });

/**
 * @param children {Array} array of elements
 * @returns {{component: *, index: number}|boolean|*}
 */
export const hasSymbolChild = children => findComponentBy(children, { path: 'symbol.childId', has: true });

/**
 * Get symbol instance model by his reference in card card tree
 *
 * @param {Object} ref - symbol instance reference
 * @param {String} ref.masterId
 * @param {String} ref.instanceId
 * @param {Object} symbols - story symbols collection
 * @returns {Object|undefined} - Instance object model
 */
export const getInstanceByRef = (ref: BBSymbolInfo | undefined, symbols: StorySymbols = {}) => {
	if (!ref) return null;
	return symbols[ref.masterId]?.instance[ref.instanceId];
};
